import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilterApiService {

  constructor(
    private _http: HttpClient
  ) { }

  //#region Program Increments APIs
  public getProAndSitePIData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForProAndSite${params}`);
  }

  public getGoPIData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForGo${params}`);
  }

  public getFPPIData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForFP${params}`);
  }

  public getCloudPIData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForCloud${params}`);
  }

  public getDCPPIData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForDCP${params}`);
  }

  public getTIAV17Data(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForTIAV17${params}`);
  }

  public getSystemTestData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForSystemTest${params}`)
  }

  public getKNXData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForKNX${params}`)
  }

  public getMBusData(viewtype?: string): Observable<any> {
    const params = viewtype ? `?viewtype=${encodeURIComponent(viewtype)}` : '';
    return this._http.get(`${environment.resourceServerURL}/filter/programIncrementForMBus${params}`)
  }
  //#endregion

  //#region Test cases APIs
  public getProTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/pro`);
  }

  public getSiteTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/site`);
  }

  public getGoTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/go`);
  }

  public getFPTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/fp`);
  }

  public getCloudTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/cloud`);
  }

  public getDCPTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/dcp`);
  }

  public getTIAV17TestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/tiav17`)
  }

  public getSystemTestTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/st`)
  }

  public getKNXTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/knx`)
  }

  public getMBusTestcaseData(): Observable<any> {
    return this._http.get(`${environment.resourceServerURL}/filter/testcases/mbus`)
  }
  //#endregion
}
